import { useEffect, useState } from 'react';
import Packages from '../../api/controllers/Packages/Packages';
import PackageList from '../../common/PackageList/PackageList';
import './Unmeasured.scss';
import Header from '../../common/Header/Header';
import Error from '../../common/Error/Error';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import Hub from '../../api/controllers/Hub/Hub';

const Unmeasured = () => {
  const [groupedPackages, setGroupedPackages] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [bays, setBays] = useState();
  const [racks, setRacks] = useState();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const getPackages = () => {
    const params = { hubId: hubId, status: 'in_warehouse', measured: false };
    setLoading(true);
    Packages.all(params)
      .then(response => {
        setGroupedPackages(Object.groupBy(response?.items, ({ job }) => job?.jobReference));
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getBays = () => {
    Hub.show(hubId)
      .then(response => {
        setBays(response.bays.filter(bay => bay.bayType != 'racking'));
        const racks = response.bays.filter(bay => bay.bayType == 'racking');
        setRacks(Object.groupBy(racks, rack => rack.bayNumber));
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getPackages();
    getBays();
  }, []);

  return (
    <div className="unmeasured_container">
      <Header title={'Dimensions'} rightButton={'home'} />
      {error && (
        <Error
          errorMessages={error}
          type={'info'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's occurred:' : ' occurred:'} `
              : ''
          }
        />
      )}
      {loading && <LoadingSpinner />}
      {groupedPackages &&
        Object.keys(groupedPackages).map(key => {
          return (
            <PackageList
              type={'unmeasured'}
              job={key}
              packages={groupedPackages[key]}
              key={key}
              refetchPackages={getPackages}
              bays={bays}
              racks={racks}
            />
          );
        })}
    </div>
  );
};

export default Unmeasured;
